import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import { useBooking } from '../context/BookingContext';
import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = () => {
  const { state, dispatch } = useBooking();
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // FIX: Handle timezone issues by setting time to noon (12:00) local time
  const handleDateChange = (dates) => {
    const [start, end] = dates;
    
    // FIX: Set time to noon to avoid timezone issues
    const normalizeDate = (date) => {
      if (!date) return null;
      const normalized = new Date(date);
      normalized.setHours(12, 0, 0, 0); // Set to noon to avoid DST and timezone issues
      return normalized;
    };

    const normalizedStart = normalizeDate(start);
    const normalizedEnd = normalizeDate(end);
    
    dispatch({ type: 'CLEAR_CART' });
    dispatch({
      type: 'UPDATE_SEARCH_STATE',
      payload: { 
        checkin: normalizedStart, 
        checkout: normalizedEnd 
      }
    });

    if (normalizedStart && normalizedEnd) {
      setTimeout(() => {
        dispatch({ type: 'PERFORM_SEARCH', payload: {} });
      }, 400);
    }
  };

  // FIX: Also fix the formatting in the display
  const formatDateForDisplay = (date) => {
    if (!date) return '';
    // Use local date formatting
    const d = new Date(date);
    return d.toLocaleDateString('en-US', { 
      day: '2-digit', 
      month: 'short', 
      year: '2-digit' 
    });
  };

  const LuxuryInput = React.forwardRef(({ value, onClick }, ref) => {
    // FIX: Use the new formatting function
    const displayStart = state.searchState.checkin 
      ? formatDateForDisplay(state.searchState.checkin)
      : 'Select Date';
    
    const displayEnd = state.searchState.checkout 
      ? formatDateForDisplay(state.searchState.checkout)
      : 'Select Date';

    return (
      <div 
        ref={ref}
        onClick={onClick}
        className="flex items-center bg-white border border-gray-200 rounded-xl h-12 hover:border-gray-400 transition-all cursor-pointer shadow-sm divide-x divide-gray-100 md:min-w-[340px] w-full"
      >
        <div className="pl-4 pr-1">
          <svg className="w-5 h-5 text-gray-400 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <div className="flex-1 px-4">
          <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest leading-tight">Check-In</p>
          <p className="text-[14px] font-bold text-gray-900 leading-tight whitespace-nowrap">
            {displayStart}
          </p>
        </div>
        <div className="flex-1 px-4 border-l border-gray-100">
          <p className="text-[9px] font-bold text-gray-400 uppercase tracking-widest leading-tight">Check-Out</p>
          <p className="text-[14px] font-bold text-gray-900 leading-tight whitespace-nowrap">
            {displayEnd}
          </p>
        </div>
      </div>
    );
  });

  LuxuryInput.displayName = 'LuxuryInput';

  // FIX: Set minDate properly to avoid timezone issues
  const getMinDate = () => {
    const today = new Date();
    today.setHours(12, 0, 0, 0); // Set to noon for consistency
    return today;
  };

  return (
    <div className="custom-datepicker-container w-full">
      <DatePicker
        selectsRange={true}
        startDate={state.searchState.checkin}
        endDate={state.searchState.checkout}
        onChange={handleDateChange}
        monthsShown={isMobile ? 1 : 2}
        minDate={getMinDate()} // FIX: Use the normalized min date
        dateFormat="dd MMM yy"
        customInput={<LuxuryInput />}
        shouldCloseOnSelect={true}
        popperPlacement={isMobile ? "bottom" : "bottom-start"}
        wrapperClassName="w-full"
      />
    </div>
  );
};

export default CustomDatePicker;